export class GQLParamBuilder {
  #isMutation = false; //Default query
  #operation;
  #variables;
  #fetchPolicy;
  #client;

  constructor(client, fetchPolicy = "network-only") {
    this.client = client;
    this.fetchPolicy = fetchPolicy;
  }

  setIsMutation() {
    this.#isMutation = true;
  }

  setOperation(operation) {
    this.#operation = operation;
  }

  setVariables(variables) {
    this.#variables = variables;
  }

  setFetchPolicy(fetchPolicy) {
    this.#fetchPolicy = fetchPolicy;
  }

  async exec() {
    let result;

    if (this.#isMutation) {
      result = await this.client.mutate({
        mutation: this.#operation,
        variables: { ...this.#variables }
      });
    } else {
      result = await this.client.query({
        query: this.#operation,
        fetchPolicy: this.#fetchPolicy,
        variables: { ...this.#variables }
      });
    }

    return result;
  }
}
